import { STRING } from "@constants";
import { ContractDetail } from "@types";
import { formatDate } from "@utils";

const T = STRING.CONTRACT_DETAILS;

const formatCurrency = (value: string | null | undefined) => {
  if (!value) return "-";
  const num = parseFloat(value);
  return isNaN(num) ? "-" : `$${num.toFixed(2)}`;
};

export function getContractDetailsSections(data?: ContractDetail | null) {
  if (!data) return { sections: [] };

  const c = data.contract;
  const entity = data.entity;
  const loc = data.location;

  const sections: any[] = [];

  // Contract Info
  sections.push({
    title: T.CONTRACT_INFO,
    icon: "pi-file",
    fields: [
      { label: T.CONTRACT_NUMBER, value: c.contractNumber },
      {
        label: T.CUSTOMER,
        value: entity
          ? `${entity.firstName || ""} ${entity.lastName || ""}`.trim()
          : "-",
      },
      { label: T.EMAIL, value: entity?.email, icon: "pi-envelope" },
      { label: T.UNIT, value: c.unitName },
      { label: T.SIZE, value: c.unitSize || data.size?.description },
      {
        label: T.LOCATION,
        value: loc?.locationName,
        icon: "pi-map-marker",
      },
      { label: T.MOVED_IN, value: formatDate(c.movedIn), icon: "pi-calendar" },
      { label: T.ACCESS_CODE, value: c.accessCode, icon: "pi-key" },
      { label: T.RATE, value: formatCurrency(c.currentRate) },
    ],
  });

  // Payment Status
  sections.push({
    title: T.PAYMENT_STATUS,
    icon: "pi-credit-card",
    fields: [
      { label: T.BALANCE, value: formatCurrency(c.balance) },
      { label: T.PAID_THROUGH, value: formatDate(c.paidThrough), icon: "pi-calendar" },
      { label: T.DEPOSIT, value: formatCurrency(c.deposit) },
      { label: T.DELINQUENCY, value: c.delinquencyStatus || "None" },
      { label: T.AUTO_PAY, value: c.autoPayType || "Not set" },
      ...(c.movedOut
        ? [{ label: T.MOVED_OUT, value: formatDate(c.movedOut), icon: "pi-calendar" }]
        : []),
    ],
  });

  // Payment History
  const payments = data.paymentHistory || [];
  if (payments.length > 0) {
    sections.push({
      title: T.PAYMENT_HISTORY,
      icon: "pi-list",
      fields: payments.map((p) => ({
        label: formatDate(p.paymentDate),
        value: [
          formatCurrency(p.amount),
          p.approvalCode ? `Approval: ${p.approvalCode}` : null,
          p.receiptID ? `Receipt: ${p.receiptID}` : null,
        ]
          .filter(Boolean)
          .join(" | "),
      })),
    });
  } else {
    sections.push({
      title: T.PAYMENT_HISTORY,
      icon: "pi-list",
      fields: [{ label: T.NO_PAYMENTS, value: "-" }],
    });
  }

  return { sections };
}
